/**
 * SNAKE-30: gating for the king-of-the-hill marquee on the main menu.
 *
 * Old behaviour (SNAKE-15): marquee was always visible, with a static
 * placeholder "Стань царём горы — выноси больше всех Stars сегодня!"
 * when no king was active.
 *
 * New behaviour (SNAKE-30):
 *   - Hide the marquee entirely when there is no king, or when the king's
 *     message is the default server-generated "👑 Царь горы: {name}".
 *   - Render only genuine custom UGC messages.
 *
 * This makes the marquee's appearance an event again instead of permanent
 * visual noise on the main menu.
 */

export interface KingMarqueeGate {
  shouldShow: boolean
  text: string
}

// Server-default placeholder formats. We strip these to keep marquee meaningful.
const DEFAULT_PATTERNS = [
  /^👑\s*Царь горы:/u,
  /^👑\s*King of the hill:/iu,
]

export function gateKingMarquee(rawMessage: string | null | undefined): KingMarqueeGate {
  if (typeof rawMessage !== 'string') return { shouldShow: false, text: '' }
  const trimmed = rawMessage.trim()
  if (trimmed.length === 0) return { shouldShow: false, text: '' }
  for (const pattern of DEFAULT_PATTERNS) {
    if (pattern.test(trimmed)) return { shouldShow: false, text: '' }
  }
  return { shouldShow: true, text: trimmed }
}
